import React from 'react';
import PropTypes from 'prop-types';
import { getOrders } from '../../api/order';
import { getTrades } from '../../api/trade';
import { getIdqsOrders } from '../../api/idqsOrder';
import { getIdqsTrades } from '../../api/idqsTrade';
import { getNmsOrders } from '../../api/nmsOrder';
import { getNmsTrades } from '../../api/nmsTrade';
import { Popup, ScrollView } from 'devextreme-react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import styles from './MasterDetailOrderGrid.module.scss';
import { Loading } from '../Loading';
import { Outline } from '@otcmarketsgroup/otcm-ui';
import { format } from '../../util/locale';

const formatDate = date => {
  return format(date, date, 'date');
};

var noSort = {
  mode: 'none'
};
var noPaging = {
  enabled: false
};

class MasterDetailOrderGrid extends React.Component {
  constructor (props) {
    super(props);
    this.state = {

      orderData: [],
      isLoaded: false,
      isReloading: false,
      // trades
      tradeData: [],
      isTradesLoaded: false,
      isTradesReloading: false

    };
    this.getChildEcnOrders = this.getChildEcnOrders.bind(this);
    this.getMatchingEcnTrades = this.getMatchingEcnTrades.bind(this);

    this.getChildIdqsOrders = this.getChildIdqsOrders.bind(this);
    this.getMatchingIdqsTrades = this.getMatchingIdqsTrades.bind(this);

    this.getChildNmsOrders = this.getChildNmsOrders.bind(this);
    this.getMatchingNmsTrades = this.getMatchingNmsTrades.bind(this);
  }

  componentDidMount () {
    if (this.props.context && this.props.context === 'idqs') {
      this.getChildIdqsOrders(this.props.data, this.props.filter);
      this.getMatchingIdqsTrades(this.props.data);
    } else if (this.props.context && this.props.context === 'nms') {
      this.getChildNmsOrders(this.props.data, this.props.filter);
      this.getMatchingNmsTrades(this.props.data);
    } else {
      this.getChildEcnOrders(this.props.data, this.props.filter);
      this.getMatchingEcnTrades(this.props.data);
    }
  }

  getMatchingEcnTrades (data) {
    // category 8 or CROSS , order status  =cancelled does not have trades

    let params = {};
    params.clientOrderId = data.clientOrderId;
    params.startDate = data.orderDate;
    params.endDate = data.orderDate;
    params.symbol = data.symbol;

    getTrades(params)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isTradesLoaded: true,
          isTradesReloading: false,
          tradeData: data.results

        }));
      }).catch((error) => {
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
          // error
        this.setState(prevState => ({
          isTradesLoaded: true,
          isTradesReloading: false,
          tradeData: [],
          tradeError: message

        }));
        console.log(error);
      });
  }

  getMatchingIdqsTrades (data) {
    let params = {};
    params.clientOrderId = data.clientOrderId;
    params.startDate = data.orderDate;
    params.endDate = data.orderDate;
    params.symbol = data.symbol;

    getIdqsTrades(params)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isTradesLoaded: true,
          isTradesReloading: false,
          tradeData: data.results

        }));
      }).catch((error) => {
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
          // error
        this.setState(prevState => ({
          isTradesLoaded: true,
          isTradesReloading: false,
          tradeData: [],
          tradeError: message

        }));
        console.log(error);
      });
  }

  getMatchingNmsTrades (data) {
    let params = {};
    params.clientOrderId = data.clientOrderId;
    params.startDate = data.orderDate;
    params.endDate = data.orderDate;
    params.symbol = data.symbol;

    getNmsTrades(params)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isTradesLoaded: true,
          isTradesReloading: false,
          tradeData: data.results

        }));
      }).catch((error) => {
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
          // error
        this.setState(prevState => ({
          isTradesLoaded: true,
          isTradesReloading: false,
          tradeData: [],
          tradeError: message

        }));
        console.log(error);
      });
  }

  getChildEcnOrders (data, filter) {
    let params = {};
    params.linkId = data.linkId;
    params.startDate = data.orderDate;
    params.endDate = data.orderDate;
    params.symbol = data.symbol;

    if (filter) {
      params.category = filter.category;
      params.orderStatus = filter.orderStatus;
    }
    getOrders(params)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          orderData: data.results

        }));
      }).catch((error) => {
        var message = (error && error.response && error.response.data) || 'Data currently unavailable';
        // error
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          orderData: [],
          error: message

        }));
        console.log(error);
      });
  }

  getChildIdqsOrders (data, filter) {
    let params = {};
    params.linkId = data.linkId;
    params.startDate = data.orderDate;
    params.endDate = data.orderDate;
    params.symbol = data.symbol;

    if (filter) {
      params.category = filter.category;
      params.orderStatus = filter.orderStatus;
    }
    getIdqsOrders(params)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          orderData: data.results

        }));
      }).catch((error) => {
        var message = (error && error.response && error.response.data) || 'Data currently unavailable';
        // error
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          orderData: [],
          error: message

        }));
        console.log(error);
      });
  }

  getChildNmsOrders (data, filter) {
    let params = {};
    params.linkId = data.linkId;
    params.startDate = data.orderDate;
    params.endDate = data.orderDate;
    params.symbol = data.symbol;

    if (filter) {
      params.category = filter.category;
      params.orderStatus = filter.orderStatus;
    }
    getNmsOrders(params)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          orderData: data.results

        }));
      }).catch((error) => {
        var message = (error && error.response && error.response.data) || 'Data currently unavailable';
        // error
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          orderData: [],
          error: message

        }));
        console.log(error);
      });
  }

  hidePopup = () => {
    this.props.clearSelection();
  }

  renderTitle = () => {
    const { data } = this.props;

    return <div className='dx-toolbar dx-widget dx-visibility-change-handler dx-collection dx-popup-title' style={{ border: 'unset', padding: '0' }} role='toolbar'>
      <div className='dx-toolbar-items-container'>
        <div className='dx-toolbar-before'>
          <div className='dx-item dx-toolbar-item dx-toolbar-label'>
            <div className='dx-item-content dx-toolbar-item-content'>
              <div>
                Date: <b>{formatDate(data.orderDate)}</b> | Cl Ord ID: <b>{data.clientOrderId}</b> | Symbol: <b>{data.symbol}</b>
              </div>
            </div>
          </div>
        </div>
        <div className='dx-toolbar-center' />
        <div className='dx-toolbar-after'>
          <div className='dx-item dx-toolbar-item dx-toolbar-button'>
            <div className='dx-item-content dx-toolbar-item-content'>
              <div className='dx-closebutton dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-icon' role='button' aria-label='close' tabIndex='0'>
                <div className='dx-button-content'><i className='dx-icon dx-icon-close' onClick={this.hidePopup} /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }

  render () {
    return (
      <div id='orderDetails'>
        <Popup
          visible
          hideOnOutsideClick
          showTitle
          titleRender={this.renderTitle}
          showCloseButton
          dragEnabled={false}
          width={'90vw'}
          onHidden={this.hidePopup}
        >
          <ScrollView width='100%' showScrollbar={'onHover'} direction={'both'}>
            <div >
              <div id='orderHistory' className={styles.orderHistory}>
                <Outline
                  mode='headingSmall'
                  bottomBorderOnly={false}
                  topBorderOnly={false}
                  className={styles.contentHeader}
                >Order History</Outline>
                <Loading
                  data={this.state.orderData}
                  loaded={this.state.isLoaded}
                  reloading={this.state.isReloading}
                  error={this.state.error}
                  emptyMessage='No results found.' >
                  <DataGrid
                    dataSource={this.state.orderData}
                    allowColumnResizing
                    columnAutoWidth
                    rowAlternationEnabled
                    showBorders
                    paging={noPaging}
                    sorting={noSort}
                    cacheEnabled={false}
                  >
                    <Column dataField='orderTime' caption='Entered' />
                    <Column dataField='updatedTime' caption='Updated' />
                    <Column dataField='mpid' caption='MPID' />
                    <Column dataField='destination' caption='Dest.' />
                    <Column dataField='status' caption='Ord Status' />
                    <Column dataField='text' caption='Text' />
                    <Column dataField='side' caption='Side' />
                    <Column dataField='quantity' caption='Qty' />
                    <Column dataField='showQty' caption='Show Qty' />
                    <Column dataField='price' caption='Price' />
                    <Column dataField='capacity' caption='Capacity' />

                    <Column dataField='execQty' caption='Exec Qty' />
                    <Column dataField='linkAtsId' caption='Link ATS ID' />
                    <Column dataField='leavesQty' caption='Lvs Qty' />
                    <Column dataField='clientTif' caption='TIF' />

                    <Column dataField='orderId' caption='Ord ID' />
                    <Column dataField='orderType' caption='Ord Type' />
                    <Column dataField='pegType' caption='Peg Type' />
                    <Column dataField='fixTag2' caption='Exec Inst.' />
                    <Column dataField='userId' caption='Fix Session' />
                    <Column dataField='contraOrderId' caption='Contra Ord ID' />

                    <Column dataField='tradeSession' caption='Trade Session' />
                    <Column dataField='senderTraderId' caption='Sender Trader' />
                    <Column dataField='unsolicited' caption='Unsolicited' />
                    <Column dataField='insideBid' caption='Inside Bid' />
                    <Column dataField='insideAsk' caption='Inside Ask' />
                    <Column dataField='routeId' caption='Route ID' />
                    <Column dataField='fixTags' caption='FixTags' />
                    <Column dataField='nonAffiliate' caption='Non Affiliate' />

                  </DataGrid>
                </Loading>
              </div>
              <div className={styles.tradeHistory}>
                <Outline
                  mode='headingSmall'
                  bottomBorderOnly={false}
                  topBorderOnly={false}
                  className={styles.contentHeader}
                >Trades</Outline>
                <Loading
                  data={this.state.tradeData}
                  loaded={this.state.isTradesLoaded}
                  reloading={this.state.isTradesReloading}
                  error={this.state.tradeError}
                  emptyMessage='No results found.' >
                  <DataGrid
                    dataSource={this.state.tradeData}
                    allowColumnResizing
                    columnAutoWidth
                    rowAlternationEnabled
                    showBorders
                    paging={noPaging}
                    sorting={noSort}
                    cacheEnabled={false}
                  >
                    <Column dataField='tradeTime' caption='Entered' />
                    <Column dataField='venue' caption='Venue' />
                    <Column dataField='mpid' caption='MPID' cellRender={this.formatMpid} />
                    <Column dataField='tradeSide' caption='Side' />
                    <Column dataField='execQty' caption='Exec Qty' dataType='string' alignment='right' />
                    <Column dataField='execPrice' caption='Price' dataType='string' alignment='right' />
                    <Column dataField='notional' caption='Notional' alignment='right' />
                    <Column dataField='liquidityIndicator' caption='Liq Ind' />
                    <Column dataField='orderCapacity' caption='Ord Capacity' />
                    <Column dataField='execId' caption='Exec ID' />
                    <Column dataField='exchangeRef' caption='Ex Ref' />
                    <Column dataField='userId' caption='User ID' />

                    <Column dataField='broker' caption='Contra Bkr' />

                  </DataGrid>
                </Loading>
              </div>
            </div>
          </ScrollView>
        </Popup>
      </div>
    );
  }
}

export default MasterDetailOrderGrid;

MasterDetailOrderGrid.propTypes = {
  data: PropTypes.object.isRequired,
  context: PropTypes.string,
  filter: PropTypes.any.isRequired,
  clearSelection: PropTypes.func.isRequired

};
